import OverlineText from './OverlineText';
export default OverlineText;